module.exports = {"apiAddress":"#{Api_Address}","socketIOAddress":"#{Socket_IO_Address}","port":"#{Web_Server_Listen_Port}","imageServeUrl":"#{Image_Store_Url}","assetImageServeUrl":"#{Asset_Image_Store_Url}"}


//////////////////
// WEBPACK FOOTER
// D:/Work/Development/vsts_build/_work/2/s/web/config/config.json
// module id = CQsZ
// module chunks = 1